import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import {
  COLLECTIONS_GET_TABLE_SETTINGS_BEGIN,
  COLLECTIONS_GET_TABLE_SETTINGS_SUCCESS,
  COLLECTIONS_GET_TABLE_SETTINGS_FAILURE,
  COLLECTIONS_GET_TABLE_SETTINGS_DISMISS_ERROR,
} from './constants';

export function getTableSettings(args = {}) {
  return (dispatch) => {
    dispatch({
      type: COLLECTIONS_GET_TABLE_SETTINGS_BEGIN,
    });
    const { projectId, version, collectionName } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/table-settings/${projectId}/${collectionName}/col-settings`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: COLLECTIONS_GET_TABLE_SETTINGS_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: COLLECTIONS_GET_TABLE_SETTINGS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissGetTableSettingsError() {
  return {
    type: COLLECTIONS_GET_TABLE_SETTINGS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COLLECTIONS_GET_TABLE_SETTINGS_BEGIN:
      return {
        ...state,
        getTableSettingsPending: true,
        getTableSettingsError: null,
      };

    case COLLECTIONS_GET_TABLE_SETTINGS_SUCCESS:
      return {
        ...state,
        getTableSettingsPending: false,
        getTableSettingsError: null,
      };

    case COLLECTIONS_GET_TABLE_SETTINGS_FAILURE:
      return {
        ...state,
        getTableSettingsPending: false,
        getTableSettingsError: action.data.error,
      };

    case COLLECTIONS_GET_TABLE_SETTINGS_DISMISS_ERROR:
      return {
        ...state,
        getTableSettingsError: null,
      };

    default:
      return state;
  }
}
